function hasForbiddenChars (value: string): boolean {
  return [...value].some((char) => {
    const code = char.charCodeAt(0);
    return code <= 0x1F || code === 0x7F || char === '\\';
  });
}

export function getSafeRedirectPath (value: unknown, fallback = '/'): string {
  if (typeof value !== 'string') {
    return fallback;
  }

  if (!value.startsWith('/') || value.startsWith('//') || hasForbiddenChars(value)) {
    return fallback;
  }

  return value;
}
